/* ipl-dimension-labels.js - Industrial Polymers, Sep 2026.

   ipl-product-page.liquid splits a dimensional option into one pill row per axis and names
   each axis from a "Label: value" prefix in the option value. With no prefix it falls back to
   "Option 1" / "Option 2", which tells a cut-to-size buyer nothing about which figure is which.

   A scan of every active product found 138 hitting the splitter. This names an axis ONLY when
   the value format proves what it is -- every value on that axis must match the same pattern.
   Anything unrecognised keeps the theme's own text, because a confident wrong label ("Thickness:
   1220mm long") is worse than a vague one.

   Recognised, with product counts from that scan:
     250 x 250 x 3mm        bare, bare, mm   -> Length / Width / Thickness   (42)
     20mm dia x 500mm       dia, length      -> Diameter / Length            (27)
     139mm OD x 133mm ID    bore pair        -> Outside / Inside dia.        (27)
     8mm OD x 4mm ID - pack of 3 lengths     -> Outside / Inside dia.         (3)
     500 x 500              bare, bare       -> Length / Width                (5)
     500mm x 500mm x 1mm    mm, mm, mm       -> Length / Width / Thickness    (1)
     3mm diameter x 25m     dia, length      -> Diameter / Length             (1)

   Deliberately NOT handled: "3mm x 3mm (pack of 15) x 1220mm long" (side/side/length cannot be
   told apart from the numbers) and anything already carrying a "Label:" prefix, which the theme
   names correctly on its own.
*/
(function () {
  'use strict';

  var N = '\\d+(?:\\.\\d+)?';
  var P = {
    bare: new RegExp('^' + N + '$'),
    mm:   new RegExp('^' + N + '\\s*mm$', 'i'),
    m:    new RegExp('^' + N + '\\s*m$', 'i'),
    dia:  new RegExp('^' + N + '\\s*mm\\s*(?:dia|diameter)$', 'i'),
    od:   new RegExp('^' + N + '\\s*mm\\s+OD\\b', 'i'),
    id:   new RegExp('^' + N + '\\s*mm\\s+ID\\b', 'i')
  };
  var LEN = 'Length (mm)', WID = 'Width (mm)', THK = 'Thickness (mm)';
  var DIA = 'Diameter (mm)', OUT = 'Outside dia. (mm)', INN = 'Inside dia. (mm)';

  /* key = axis classes joined by ","  ->  labels for each axis */
  var RULES = {
    'bare,bare':      [LEN, WID],
    'mm,mm':          [LEN, WID],
    'od,id':          [OUT, INN],
    'dia,mm':         [DIA, LEN],
    'dia,m':          [DIA, 'Length (m)'],
    'bare,bare,mm':   [LEN, WID, THK],
    'mm,mm,mm':       [LEN, WID, THK],
    'bare,bare,bare': [LEN, WID, THK]
  };

  var FALLBACK = /^\s*Option\s+\d+\s*$/i;

  /* every value on the axis must share one class, else the axis is unknown */
  function classOf(values) {
    var found = null;
    for (var i = 0; i < values.length; i++) {
      var cls = null;
      for (var k in P) { if (P[k].test(values[i])) { cls = k; break; } }
      if (!cls) return null;
      if (found === null) found = cls; else if (found !== cls) return null;
    }
    return found;
  }

  function labelNode(axis) {
    var el = axis.querySelector('.iplp__axis-label');
    if (!el || !el.firstChild || el.firstChild.nodeType !== 3) return null;
    return el.firstChild;
  }

  /* pill buttons hold the value; the trailing .iplp__pill-price span must not be read */
  function valuesOf(axis) {
    var out = [];
    Array.prototype.forEach.call(axis.querySelectorAll('.iplp__pills > button'), function (b) {
      var s = b.querySelector('span');
      var t = ((s ? s.textContent : b.textContent) || '').trim();
      if (t) out.push(t);
    });
    return out;
  }

  function relabel(host) {
    var axes = Array.prototype.slice.call(host.querySelectorAll('.iplp__axis'));
    if (!axes.length || axes.length > 3) return;

    var nodes = [], i;
    for (i = 0; i < axes.length; i++) {
      var n = labelNode(axes[i]);
      if (!n || !FALLBACK.test(n.nodeValue)) return;   /* theme named it: leave well alone */
      nodes.push(n);
    }

    var classes = [];
    for (i = 0; i < axes.length; i++) {
      var vals = valuesOf(axes[i]);
      if (!vals.length) return;
      var c = classOf(vals);
      if (!c) return;
      classes.push(c);
    }

    var names = RULES[classes.join(',')];
    if (!names) return;

    for (i = 0; i < axes.length; i++) {
      nodes[i].nodeValue = names[i] + ' ';
      var group = axes[i].querySelector('.iplp__pills');
      if (group) group.setAttribute('aria-label', names[i]);
    }
  }

  function init() {
    var hosts = document.querySelectorAll('[data-axes]');
    if (!hosts.length) return;
    Array.prototype.forEach.call(hosts, function (host) {
      relabel(host);
      /* the theme rebuilds host.innerHTML on every pill click */
      new MutationObserver(function () { relabel(host); }).observe(host, { childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
